import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'pt-update-form-footer-actions',
  template: `
    <div class='w-100 gap-2 form-actions-container'>
      <pt-button-with-loader
        [disabled]='saveAndCloseButtonDisabled'
        [loading]='saveAndCloseButtonLoading'
        [cssClass]="'btn btn-primary btn-sm'"
        [label]="'BUTTON.SAVE_AND_CLOSE' | translate"
        [mainIcon]='saveAndCloseButtonMainIcon'
        (buttonWithLoaderClick)='submitAndCloseClick.emit()'
        *ngIf="!enableSimpleMode"
      ></pt-button-with-loader>

      <pt-button-with-loader
        [disabled]='saveButtonDisabled'
        [loading]='saveButtonLoading'
        [label]="'BUTTON.SAVE' | translate"
        [cssClass]="'btn btn-primary btn-sm'"
        (buttonWithLoaderClick)='submitClick.emit()'
        [mainIcon]='saveButtonMainIcon'
      ></pt-button-with-loader>

      <button
        type='button'
        class='btn btn-outline-secondary btn-sm'
        [disabled]='extraButtonDisabled'
        (click)='extraButtonClick.emit()'
      >{{ extraButtonLabel }}
      </button>
    </div>
  `,
  styles: [
    `
      .btn-disabled:hover {
        color: #6c757d;
        background-color: transparent;
      }

      .form-actions-container {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        margin-bottom: 10px;
      }
    `
  ]
})
export class UpdateFormFooterActionsComponent {
  @Input() saveButtonMainIcon: string;
  @Input() saveButtonLoading: boolean;
  @Input() saveButtonDisabled: boolean;

  @Input() saveAndCloseButtonMainIcon: string;
  @Input() saveAndCloseButtonLoading: boolean;
  @Input() saveAndCloseButtonDisabled: boolean;

  @Input() extraButtonLabel: string;
  @Input() extraButtonDisabled: boolean;

  @Output() submitClick = new EventEmitter<any>();
  @Output() extraButtonClick = new EventEmitter<any>();
  @Output() submitAndCloseClick = new EventEmitter<any>();

  public enableSimpleMode = false;

  constructor() {
    //todo @georgy
    // condizione temporale mentre si migrano le notifiche
    const pathName = window.location.pathname;
    const dpg = pathName.includes('data-protection-governance');
    const amd = pathName.includes('administration-configuration');
    this.enableSimpleMode = dpg || amd;
  }
}
